module.exports = __webpack_public_path__ + "res/ic_add_audio.de727aba98a61b838a78551069cf06cf.png";